module.exports = __webpack_public_path__ + "static/img/14000661.37dc5a8c.png";